<template>
    <v-container fluid>
        <fl-filter v-if="distributor" :location-id="$route.params.id" @applyFilters="loadItems"></fl-filter>
        <div v-if="distributor">
            <div>
                <img :src="distributor.logo" class="dist-logo"/>
            </div>
        </div>
        <v-btn @click="toggleFilter" class="ma-3" small>
            <v-icon>mdi-filter</v-icon>Filter
        </v-btn>

        <div v-if="!executing && foundCount===0">
            Sorry, there are currently no items available.
        </div>

        <div v-if="!executing && items.length >0">
            <v-row>
                <v-col :cols="columnCount"
                       :key="item.id"
                       v-for="item in items"
                >
                    <v-card>
                        <v-card-text class="text-center">
                            <h2>{{item.productName}}</h2>
                            <h3>{{formatPrice(item.sellPrice)}}</h3>
                            <div :style="{backgroundImage: 'url(\'' + item.image + '\')'}" class="logo-container mt-6">

                            </div>


                            <v-divider></v-divider>
                            <div>
                                <v-spacer></v-spacer>
                                <div>
                                    <v-btn :disabled="!item.biography" @click="moreInfo(item)" class="ma-4" small>
                                        <v-icon dark left>mdi-information-variant</v-icon>
                                        More Info
                                    </v-btn>
                                </div>
                                <div v-if="loggedIn">
                                    <v-text-field :rules="qtyRules" label="Quantity" type="number" v-model="item.quantity"/>
                                    <v-btn :disabled="item.quantity <= 0" @click="addToCart(item)" class="ma-4" small>
                                        <v-icon dark left>mdi-plus-circle</v-icon>
                                        Add to Cart
                                    </v-btn>
                                </div>
                                <div v-if="!loggedIn">
                                    Login or register to add to cart.
                                </div>
                            </div>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <v-dialog v-if="currentItem"
                  v-model="moreInfoModal">

            <v-card>
                <v-card-title class="headline grey lighten-2"
                              primary-title>
                    {{currentItem.productName}}
                </v-card-title>
                <v-card-text class="mt-4" v-html="currentItem.biography">
                </v-card-text>
                <v-divider v-if="currentItem.attributes.length>0"></v-divider>
                <v-card-text v-if="currentItem.attributes.length>0">
                    <h3>Product Attributes</h3>
                    <v-chip :key="attr.id" class="ma-2"
                            color="primary"
                            label
                            small
                            v-for="attr in currentItem.attributes"
                    >
                        {{attr.name}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="moreInfoModal=false" small>
                        <v-icon dark left>mdi-check-circle</v-icon>
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="error white--text">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
                v-model="snackbar"
                :timeout = "snackbarTimeout"
                top
        >
            {{ snackbarText }}
            <v-btn
                    color="pink"
                    text
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>


    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api";
    import store from "../store";
    import flFilter from "./Filter";
    import moment from 'moment';
    import { mapState } from 'vuex';

    export default {
        name: 'Shop',
        components: {
            flFilter
        },
        computed: {
            filters: function() {
                return this.$store.state.filters
            },
            columnCount: function () {
                let cols = 12;
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': {
                        cols = 12
                        break;
                    }
                    case 'sm': {
                        cols = 6
                        break;
                    }
                    case 'md': {
                        cols = 4
                        break;
                    }
                    case 'lg': {
                        cols = 3
                        break;
                    }
                    case 'xl': {
                        cols = 2
                        break;
                    }
                }
                return cols
            },
            pickupLocation: function() {
                return this.$store.state.pickupFilters.pickupLocation;
            },
            pickupDate: function () {
                return this.$store.state.pickupFilters.date;
            },
            pickupTime: function () {
                return this.$store.state.pickupFilters.time;
            },
            ...mapState([
                'apiKey',
                'userDetails',
                'loggedIn',
                'executing'
            ])
        },
        data: () => ({
            showNotFound: false,
            errorText: "",
            errorDialog: false,
            moreInfoModal: false,
            distributor: null,
            totalItems: 0,
            items: [],
            currentItem: null,
            snackbar: false,
            snackbarText: "",
            snackbarTimeout: 2500,
            offset: 0,
            foundCount: null,
            qtyRules: [
                v => v >= 0 || "Quantity can't be less than 0"
            ]
        }),
        mounted() {
            window.scrollTo(0, 0)
            this.$store.dispatch("setExecuting", true)
            api.get("/consumer/distributor/" + this.$route.params.id).then(
            (results) => {
                this.distributor = results.data
                this.loadItems()
            },
            (error) => {
                this.errorText = error.response.data
                this.errorDialog = true
                this.$store.dispatch("setExecuting", false)
            })

        },
        methods: {
            formatPrice(value) {
                let val = (value / 1).toFixed(2)
                return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            addToCart(item) {
                this.$store.dispatch("setExecuting", true);
                let quantity = parseInt(item.quantity);
                let pickupTime = moment.utc(this.pickupTime);
                let pickupSlot = moment.utc(this.pickupDate)
                    .startOf('day')
                    .hour(pickupTime.hour())
                    .minute(pickupTime.minute());

                api.post("/consumer/addToCart/", {itemId: item.id, quantity: quantity,
                    pickupTime: pickupSlot.format('YYYY-MM-DD[T]HH:mm'), pickupLocation: this.pickupLocation }).then(
                (results) => {
                    item.quantity = 0
                    this.snackbarText = "Item added to cart successfully."
                    this.snackbar = true
                    store.dispatch("setCartSize", results.data.cartSize)
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            loadItems() {
                this.$store.dispatch("setExecuting", true)
                api.post("/consumer/items/" + this.$route.params.id + "?offset=" + this.offset,this.filters).then(
                (results) => {
                    this.foundCount = results.data.count
                    this.items = results.data.items
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            bcClick(item) {
                if (item.action) {
                    if (item.action == "catList") {
                        this.bcItems[1].disabled = true
                        this.currentCategory = null
                        this.items = []
                        this.bcItems.length = 2
                        return
                    }
                }

                //todo -- check for items in cart before going to dest
                this.$router.push(item.href)
            },
            loadLocations(offset) {
                this.$store.dispatch("setExecuting", true)
                api.get("/consumer/listLocations?offset=" + offset).then(
                (results) => {
                    this.locations = results.data.locations
                    this.totalLocations = results.data.totalCount
                },
                (error) => {
                    if (error.response.status == 403) {
                        this.$router.push("/login")
                    }
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            moreInfo(item) {
                this.currentItem = item
                this.moreInfoModal = true
            },
            toggleFilter() {
                this.$store.dispatch("toggleFilter")
            },
        }
    }
</script>
<style scoped>
    .dist-logo {
        max-height: 100px;
    }

    .logo-container {
        height: 300px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 5px;
        margin: 5px 0;
    }

</style>